module.exports = function(cb) {
	require.ensure([], function(require) {
		cb(require("!!../../../../node_modules/happypack/loader.js?id=jsx!./AiVideoDetailView.js"));
	}, "AiVideoDetailView");
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/bundle-loader?lazy&name=AiVideoDetailView!./src/pages/AICreation/AiVideoDetail/AiVideoDetailView.js
// module id = 826
// module chunks = 431